import(/* webpackMode: "eager", webpackExports: ["NamespaceNavTabs"] */ "/actions-runner/_work/oxenhub-nextjs/oxenhub-nextjs/src/components/NamespaceHeader/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/actions-runner/_work/oxenhub-nextjs/oxenhub-nextjs/src/ui/Header/NamespaceHeader/index.tsx");
